import { i18n } from '@lingui/core';
import { getParamByName } from '../config';

// catalog imports
import catalogEn from '../../locale/en/messages.json';
import catalogMx from '../../locale/es-mx/messages.json';

const catalogs = {
    en: catalogEn,
    'es-mx': catalogMx
};

export const DEFAULT_LOCALE_DATA = {
    en: { plurals: catalogEn }
};

export const DEFAULT_LOCALE_OPTIONS = {
    locale: 'en'
};

export function getLocale() {
    const locale = getParamByName('locale');
    return locale ? locale.toLowerCase() : DEFAULT_LOCALE_OPTIONS.locale;
}

export function i18nSetup(localeOverride) {
    // get locale from query parameter, default to en
    let locale = localeOverride || getLocale() || DEFAULT_LOCALE_OPTIONS.locale;

    if (catalogs[locale] === undefined) {
        locale = DEFAULT_LOCALE_OPTIONS.locale;
    }

    i18n.load(locale, catalogs[locale].messages);
    i18n.activate(locale);
 }
